import { useEffect, useState, useMemo } from "react";
import ShortsVideo from "./ShortsVideo";
import "./ShortsPage.css";
import { fetchYoutubeShorts } from "../../api/youtubeShorts.api";

function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function ShortsPage() {
  const [videos, setVideos] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const load = async () => {
      const data = await fetchYoutubeShorts();
      const list = Array.isArray(data) ? data : [];

      // ✅ remove duplicates by videoId
      const unique = Array.from(new Map(list.map(v => [v.videoId, v])).values());

      // ✅ shuffle
      const shuffled = shuffleArray(unique);

      setVideos(shuffled);
      setActiveIndex(0);
    };
    load();
  }, []);

  // ✅ keep only 3 videos in DOM for speed
  const visibleVideos = useMemo(() => {
    if (!videos.length) return [];
    const start = Math.max(activeIndex - 1, 0);
    const end = Math.min(activeIndex + 2, videos.length);
    return videos.slice(start, end).map((v, i) => ({
      ...v,
      realIndex: start + i,
    }));
  }, [videos, activeIndex]);

  return (
    <div className="shorts-wrapper">
      <div className="shorts-feed">
        {visibleVideos.map((video) => (
          <ShortsVideo
            key={`${video.videoId}-${video.realIndex}`}
            video={video}
            active={video.realIndex === activeIndex}
            onVisible={() => setActiveIndex(video.realIndex)}
          />
        ))}
      </div>
    </div>
  );
}

export default ShortsPage;
